import useAppStore from "@/context/store";
import { getGdUserOrgs } from "@/services";
import { getOrgIdByUser, isGdMerged as isGdMergedFn } from "@/utils/gaoding";
import { ORG_CONTACT_SOURCE } from "@/utils/gd-org";
import useReq from "@/utils/useReq";
import { isArray } from "lodash";
import { useEffect, useMemo, useState } from "react";
import GdOrgList from "../GdOrgList";
import HBModal, { ModalProps } from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

interface IProps {
  orgList?: IGdOrgInfo[];
  onClose: () => void;
  onCancel?: () => void;
  onOk?: () => void;
}

export function useOrgList() {
  const user = useAppStore((s) => s.user);
  const isGdMerged = isGdMergedFn(user);

  const {
    data: orgList,
    loading,
    refresh,
  } = useReq(
    async () => {
      if (!isGdMerged || !user) {
        return [];
      }
      return getGdUserOrgs();
    },
    {
      refreshDeps: [isGdMerged],
    }
  );

  const currentOrgId = getOrgIdByUser(user);

  const currentOrg = useMemo(() => {
    if (isArray(orgList)) {
      return orgList.find((org) => org.org_id === currentOrgId);
    }
  }, [orgList, currentOrgId]);

  return {
    currentOrg,
    orgList,
    loading,
    refresh,
  };
}

export function RawGdOrgSwitchDialog(props: IProps & ModalProps) {
  const [org, setOrg] = useState(null);

  const { data: orgList } = useReq(async () => {
    if (props.orgList) {
      return props.orgList;
    }

    return getGdUserOrgs();
  });

  useEffect(() => {
    if (orgList && orgList.length) {
      const currentOrgId = getOrgIdByUser(useAppStore.getState().user);
      setOrg(orgList.find((org) => org.org_id === currentOrgId));
    }
  }, [orgList]);

  return (
    <HBModal
      {...props}
      width={450}
      title="切换组织"
      footer={null}
      className={styles.modal}
      bodyStyle={{ padding: 0 }}
    >
      <div className={styles.list}>
        <GdOrgList
          value={org}
          dataSource={orgList}
          autoSwitchOnClick={true}
          showCreateButton={true}
          contactSource={
            ORG_CONTACT_SOURCE.HB_ACCOUNT_OVERVIEW_SWITCH_ORGANIZATION
          }
        />
      </div>
    </HBModal>
  );
}

const GdOrgSwitchDialog = ModalWrap(RawGdOrgSwitchDialog, {
  unique: true,
});
export default GdOrgSwitchDialog;
